// extracted by mini-css-extract-plugin
export default {"container":"Theme_container__Nk1u9","icon":"Theme_icon__cxtRl","title":"Theme_title__VcCGZ","switchContainer":"Theme_switchContainer__RmRBq"};